import { CSSProperties } from "react";

interface SingleLineProps {
  line: string;
  style?: CSSProperties;
}

export const SingleLine = ({ line, style }: SingleLineProps) => {
  return <p style={style}>{line}</p>;
};
